"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiFormControl = _interopRequireDefault(require("./HiFormControl"));
var _HiIcon = _interopRequireDefault(require("../HiIcon/HiIcon"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    barContainer: {
      width: '100%',
      position: 'relative',
      margin: '0 7px'
    },
    barHidden: {
      width: '100%',
      opacity: 0,
      position: 'absolute',
      top: '7px',
      zIndex: '2',
      cursor: 'pointer'
    },
    mainContainer: (0, _objectSpread2.default)({}, theme.typography.body2, {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center'
    }),
    topContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      height: '18px'
    },
    bottomContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      height: '18px'
    },
    barValue: {
      display: 'flex',
      width: '100%',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      zIndex: '2'
    },
    arrow: {
      position: 'absolute',
      zIndex: '1',
      transform: 'rotate(-90deg) translate(0%,-50%)',
      transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)',
      transitionProperty: 'transform color',
      fontSize: 20,
      cursor: 'pointer'
    },
    leftLabel: {
      color: theme.palette.primary.main,
      left: '0px',
      position: 'absolute',
      fontSize: '11px',
      alignSelf: 'flex-end'
    },
    rightLabel: {
      color: '#737373',
      right: '0px',
      position: 'absolute',
      fontSize: '11px',
      alignSelf: 'flex-end'
    },
    textValue: {
      position: 'absolute',
      zIndex: '2'
    },
    trackAfter: {
      backgroundColor: 'gray',
      opacity: 0.24
    },
    focused: {
      fontSize: 24,
      color: theme.palette.primary.dark
    }
  };
};

/**
 * HiSlider component
 */
var HiSlider = /*#__PURE__*/function (_React$Component) {
  function HiSlider(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSlider);
    _this = _callSuper(this, HiSlider, [props]);
    _this.handleChange = function (event) {
      _this.props.onChange(parseFloat(event.target.value));
      _this.textValueWidth = _this.textValue.offsetWidth;
    };
    _this.handleFocus = function (isFocused) {
      return function () {
        _this.setState({
          focused: isFocused
        });
      };
    };
    _this.state = {
      focused: false
    };
    return _this;
  }

  /**
   * Measures several components once they are mounted.
   * If the value and a label (left or right) are hovered,
   * we hide this label.
   */
  (0, _inherits2.default)(HiSlider, _React$Component);
  return (0, _createClass2.default)(HiSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.leftLabelWidth = this.leftLabel.offsetWidth;
      this.rightLabelWidth = this.rightLabel.offsetWidth;
      this.textValueWidth = this.textValue.offsetWidth;
      this.barContainerWidth = this.barContainer.offsetWidth;
      var _this$getHovering = this.getHovering(),
        hoveringLeft = _this$getHovering.hoveringLeft,
        hoveringRight = _this$getHovering.hoveringRight;
      if (hoveringLeft || hoveringRight) {
        this.forceUpdate();
      }
    }

    /**
     * Calculates if the labels are hovered.
     */
  }, {
    key: "getHovering",
    value: function getHovering() {
      var ratio = (this.props.value - this.props.min) / (this.props.max - this.props.min);
      var hoveringLeft = this.leftLabelWidth - (ratio * this.barContainerWidth - ratio * this.textValueWidth) > 0;
      var hoveringRight = this.barContainerWidth - ratio * this.barContainerWidth - this.rightLabelWidth - (1 - ratio) * this.textValueWidth < 0;
      return {
        hoveringLeft: hoveringLeft,
        hoveringRight: hoveringRight
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        className = _this$props.className,
        min = _this$props.min,
        max = _this$props.max,
        leftLabel = _this$props.leftLabel,
        rightLabel = _this$props.rightLabel,
        step = _this$props.step,
        suffix = _this$props.suffix,
        id = _this$props.id,
        label = _this$props.label,
        value = _this$props.value,
        theme = _this$props.theme;
      var focused = this.state.focused;
      var ratio = (value - min) / (max - min);
      var percentage = ratio * 100;
      var _this$getHovering2 = this.getHovering(),
        hoveringLeft = _this$getHovering2.hoveringLeft,
        hoveringRight = _this$getHovering2.hoveringRight;
      var barColor = focused ? theme.palette.primary.dark : theme.palette.primary.main;
      return (
        /*#__PURE__*/
        // HiFormControl pour l'affichage du label
        _react.default.createElement(_HiFormControl.default, {
          id: id,
          label: label,
          className: className,
          onFocus: this.handleFocus(true),
          onBlur: this.handleFocus(false)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.mainContainer
        }, /*#__PURE__*/_react.default.createElement("div", null, min, suffix), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.barContainer,
          ref: function ref(div) {
            _this2.barContainer = div;
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.topContainer
        }, !hoveringLeft && /*#__PURE__*/_react.default.createElement("div", {
          className: classes.leftLabel,
          ref: function ref(div) {
            _this2.leftLabel = div;
          }
        }, leftLabel), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.textValue,
          style: {
            left: "".concat(percentage, "%"),
            transform: "translate(-".concat(percentage, "%)")
          },
          ref: function ref(div) {
            _this2.textValue = div;
          }
        }, value, suffix), !hoveringRight && /*#__PURE__*/_react.default.createElement("div", {
          className: classes.rightLabel,
          ref: function ref(div) {
            _this2.rightLabel = div;
          }
        }, rightLabel)), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.barValue,
          style: {
            background: "linear-gradient(to right, ".concat(barColor, ", ").concat(barColor, " ").concat(percentage, "%, #E0E0E0 ").concat(percentage, "%, #E0E0E0)")
          }
        }), /*#__PURE__*/_react.default.createElement("input", {
          type: 'range',
          min: min,
          max: max,
          value: value,
          onChange: this.handleChange,
          className: classes.barHidden,
          step: step
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.bottomContainer
        }, /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
          className: (0, _classnames.default)(classes.arrow, (0, _defineProperty2.default)({}, classes.focused, focused)),
          icon: 'play_arrow',
          style: {
            left: "".concat(percentage, "%"),
            color: barColor
          }
        }))), /*#__PURE__*/_react.default.createElement("div", null, max, suffix)))
      );
    }
  }]);
}(_react.default.Component);
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HiSlider',
  withTheme: true
})(HiSlider);